<template>
    <div class="agent">

        <div class="tableArea">
            <div class="inln">
                <span class="tip"></span>
                <span>{{ $t('other.a213') }}</span>
            </div>
            <div class="orng">
                <el-button size="mini" v-show="!isEditor" type="primary"
                    @click="isEditor = true">{{ $t('other.a214') }}</el-button>
                <el-button size="mini" v-show="ActiveType" type="primary" @click="open">{{ $t('other.a215') }}</el-button>
                <el-button size="mini" v-show="isEditor" type="danger"
                    @click="updataPrice()">{{ $t('other.a216') }}</el-button>
                <el-button size="mini" v-show="isEditor" type="info"
                    @click="isEditor = false">{{ $t('other.a106') }}</el-button>
                <!-- <el-button style="margin-left:10px;" size="mini" type="primary" @click="unPublish()">{{$t('other.a229')}}</el-button> -->
            </div>
            <el-table :data="groupInfo.storeItems" size="mini" border
                :header-cell-style="{ background: '#e8e8e8', color: '#000' }" style="width: 100%;">
                <el-table-column prop="outTradeNo" fixed :label="$t('other.a217')" width="80">
                    <template slot-scope="props">
                        <img class="picBox" :src="props.row.image" style="width: 50px; height: 50px" />
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a218')" fixed width="100">
                    <template slot-scope="props">
                        <div>{{ props.row.skuName }}</div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a67')" fixed width="80">
                    <template slot-scope="props">
                        <div>{{ props.row.cusCode }}</div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a219')" width="80">
                    <template slot-scope="props">
                        <div>￥{{ props.row.price }}</div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a220')" width="150">
                    <template slot="header">
                        <span style="padding-right:25px">{{ $t('other.a221') }}
                            <el-tooltip class="item" effect="dark" :content="$t('other.a222')" placement="top-start">
                                <i class="el-icon-question oook"></i>:
                            </el-tooltip>
                        </span>
                        <el-input v-show="isEditor" size="mini" style="width:120px" @blur="setPrice(1)" v-model="priceValue"
                            :placeholder="$t('other.a307')"></el-input>
                    </template>
                    <template slot-scope="props">
                        <span>￥
                            <span v-show="!isEditor">{{ props.row.lowestDistributePrice }}</span>
                            <el-input v-show="isEditor" style="width:80px;margin-left:10px" size="mini"
                                v-model="props.row.lowestDistributePrice"></el-input>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="{{$t('other.a221')}}" width="160">
                <template slot-scope="props">
                  <span>￥{{props.row.lowestDistributePrice ? props.row.lowestDistributePrice :  $t('other.a354')}}</span>
                </template>
            </el-table-column> -->
                <el-table-column :label="$t('other.a223')">
                    <template slot-scope="props">
                        <div style="display:flex;border-bottom:1px solid #eee" v-for="(item, index) in props.row.agentList "
                            :key="index">
                            <div class="uiop">
                                <div>{{ $t('other.a224') }}{{ item.userName }}</div>
                                <div>{{ $t('other.a225') }}{{ item.userId }}</div>
                            </div>
                            <div class="uiop">{{ $t('other.a226') }}{{ item.cusCode }}</div>
                            <div class="uiop">{{ $t('other.a227') }}{{ item.items == null ? 0 : item.items.length }}</div>
                            <div class="uiop">{{ $t('other.a228') }}(<span
                                    style="margin-right:3px;">{{ getCur(item.country) }}</span>):
                                <span v-if="!item.priceList.length">0</span>
                                <span v-if="item.priceList.length == 1">{{ item.priceList[0] }}</span>
                                <span v-if="item.priceList.length > 1">{{ item.priceList[0] }}~{{ item.priceList[1] }}</span>
                            </div>
                            <div class="uiop">{{ $t('other.a228') }}(￥):
                                <span v-if="!item.priceList.length">0</span>
                                <span
                                    v-if="item.priceList.length == 1">{{ cruConversion(item.country, item.priceList[0]) }}</span>
                                <span v-if="item.priceList.length > 1">{{ cruConversion(item.country, item.priceList[0]) }} ~
                                    {{ cruConversion(item.country, item.priceList[1]) }}</span>
                            </div>
                            <div class="uiop">
                                <span class="btn" @click="taekDown(item)">{{ $t('other.a229') }}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { getGruopAndTempInfo } from '../../utils/toolFun'
import distributionApi from '../../api/moudles/distribution'
import utils from '../../utils/utils'
import api from '../../api/api'
export default {
    data() {
        return {
            isEditor: false,
            priceValue: null,
            type: 2,
            agenList: [],
            orderList: [],
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            value: null,
            agentInfo: null,
        }
    },
    props: ['groupInfo', 'ActiveType'],
    created() {
        console.log('----')
        console.log(this.groupInfo)
    },
    methods: {
        open() {
            let num = this.groupInfo.limitAgencyNum
            this.$prompt(this.$t('other.a230'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                inputType: 'number',
                inputValue: this.groupInfo.limitAgencyNum,
            }).then(({ value }) => {
                if (Number(value) || value == 0) {
                    this.groupInfo.limitAgencyNum = Number(value)
                    api
                        .updatelimitAgencyNum(this.groupInfo)
                        .then(res => {
                            if (res.code === 200) {
                                console.log('desc', res.data)
                                this.$message.success(this.$t('other.a231'))
                            } else {
                                this.groupInfo.limitAgencyNum = num
                                this.$message.warning(res.msg)
                            }
                        })
                } else {
                    console.log(666)
                }
            }).catch(() => {
            });
        },
        updataPrice(item) {
            this.groupInfo.storeItems.forEach(p => {
                p.lowestDistributePrice = Number(p.lowestDistributePrice)
                console.log('p', p);


            })

            distributionApi
                .putAwayToDistribution(this.groupInfo)
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.$message.success(this.$t('other.a232'))
                        this.isEditor = false

                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },
        setPrice(num) {
            console.log(this.priceValue)
            if (num == 1) {
                if (this.priceValue !== '' && this.priceValue !== null) {
                    this.groupInfo.storeItems.forEach(p => {
                        p.lowestDistributePrice = Number(this.priceValue).toFixed(2)

                    })
                }
            }
        },
        cruConversion(country, price) {
            return utils.interestRateConversion(country, price)
        },
        taekDown(item) {
            console.log(item);
            let params = {
                sellerGroup: item.groupId,
                sourceGroup: Number(this.$route.query.groupId),
                userId: this.userId
            }

            console.log('params', params)
            this.$confirm(this.$t('other.a233') + item.userName + this.$t('other.a233'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a235'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                api
                    .delistedProducts(params)
                    .then(res => {
                        if (res.code === 200) {
                            console.log('desc', res.data)
                            this.$message.success(this.$t('other.a236'))
                            location.reload();
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })

            })


            console.log('params', params);
        },
        chooseItem(num) {
            this.type = num
        },
        getCur(code) {
            return utils.getCurrency(code)
        },


        getOrderList() {
            let list = this.agentInfo[this.value]
            this.orderList = list[0].storeItems
            this.orderList.forEach(p => {
                p.country = list[0].country
            })
            console.log('list', list);
        },

        getData() {
            api
                .getAgencyProductInfo({
                    groupId: this.$route.query.groupId,
                    userId: this.userId
                })
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.agentInfo = res.data.itemGroups
                        let obj = res.data.itemGroups

                        for (let key in obj) {
                            this.agenList.push({
                                label: obj[key][0].storeItems[0].userName,
                                value: obj[key][0],
                            })
                        }
                        console.log('agenList', this.agenList)

                        // this.value=this.agenList[0].value
                        // this.orderList=this.agentInfo[this.value][0].storeItems


                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        }

    }
}

</script>
<style lang="scss" scoped>
@import "../../assets/scss/mixins";

.agent {

    background-color: #eee;

    .agentWrapper {
        margin: 10px;
        box-sizing: border-box;
        padding: 10px;
        background-color: #fff;
    }

    .uiop {
        display: inline-block;
        width: 200px;
        margin-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;

        .btn {
            background-color: #409EFF;
            box-sizing: border-box;
            padding: 10px;
            color: #fff;
            border-radius: 2px;
            cursor: pointer;
        }


    }

    .tableArea {
        box-sizing: border-box;
        margin: 10px 0 0 0;
        padding: 10px;
        background-color: #fff;

        .orng {
            display: flex;
            justify-content: flex-start;
            margin: 10px 30px;
        }

        .inln {
            @include flex-start();
            font-weight: 700;
            font-size: 16px;
            color: rgba(0, 0, 0, .85);
            padding: 10px 0;
        }

        .tip {
            display: inline-block;
            margin: 0 5px 0 0;
        }

        .tip::after {
            content: "";
            display: inline-block;
            width: 4px;
            height: 14px;
            background-color: #007bfc;
        }


    }

    .views {
        font-size: 20px;
        font-weight: 600;
        padding: 10px 0;
        color: rgba(0, 0, 0, .65);
    }

    .awrapper {
        display: flex;
        justify-content: space-between;

        .oknd {
            flex: 1;
            display: flex;
            justify-content: space-around;

            .yund {
                width: 30%;
                height: 150px;
                background-color: #fafafa;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding-left: 20px;

                .inlng {
                    font-size: 20px;
                    font-weight: 600;
                    padding-bottom: 5px;

                }

                .onirg {
                    font-size: 14px;
                }

                .yitn {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 18px;

                    img {
                        width: 70%;
                    }
                }

                .yitn:nth-child(1) {
                    background-color: #ccedff;

                }

                .yitn:nth-child(2) {
                    background-color: #fff3d7;

                }
            }

        }

        .noog {
            display: flex;
            justify-content: flex-start;
        }

        .uolp {
            width: 350px;
            box-sizing: border-box;
            padding: 0 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .bhyti {
                margin: 10px 0 0 0;
                color: rgba(0, 0, 0, .45);
            }

            .yimg {
                display: flex;
                align-content: center;
                padding: 3px 0;
                font-size: 15px;
                font-weight: 600;
            }

            .onkg {
                display: inline-block;
                width: 91px;
                text-align: right;
            }

            .onpk {
                display: inline-block;
                width: 115px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .groupName {
                font-size: 16px;
                font-weight: bold;
                color: #757575;
                @include multiline-ellipsis(3)
            }
        }

        .imgBox {
            width: 150px;
            height: 150px;
            overflow: hidden;

            img {
                width: 100%;
            }
        }
    }
}</style>